import { render, staticRenderFns } from "./PartnerContent.vue?vue&type=template&id=6228f1e4&scoped=true"
import script from "./PartnerContent.vue?vue&type=script&lang=js"
export * from "./PartnerContent.vue?vue&type=script&lang=js"
import style0 from "./PartnerContent.vue?vue&type=style&index=0&id=6228f1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228f1e4",
  null
  
)

export default component.exports